(function ($) {

    $.fn.menu = function (opts) {
        // Initialize menu for all elements in jQuery collection
        this.each(function () {
            init.call(this, opts);
        });

        return this;
    };

    function init(opts) {
        var $menu = $(this),
            activeRow = null,
            mouseLocs = [],
            lastDelayLoc = null,
            timeoutId = null,
            options = $.extend({
                rowSelector: "> li",
                submenuSelector: "*",
                submenuDirection: "right",
                tolerance: 75,
                enter: $.noop,
                exit: $.noop,
                activate: $.noop,
                deactivate: $.noop,
                exitMenu: $.noop
            }, opts);

        var MOUSE_LOCS_TRACKED = 3,
            DELAY = 300;

        var mousemoveDocument = function (e) {
            mouseLocs.push({ x: e.pageX, y: e.pageY });

            if (mouseLocs.length > MOUSE_LOCS_TRACKED) {
                mouseLocs.shift();
            }
        };

        var mouseleaveMenu = function () {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }

            if (options.exitMenu(this)) {
                if (activeRow) {
                    options.deactivate(activeRow);
                }

                activeRow = null;
            }
        };


        var mouseenterRow = function () {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }

            options.enter(this);
            possiblyActivate(this);
        },
            mouseleaveRow = function () {
                options.exit(this);
            };


        var clickRow = function () {
            activate(this);
        };

        var activate = function (row) {
            if (row == activeRow) {
                return;
            }

            if (activeRow) {
                options.deactivate(activeRow);
            }

            options.activate(row);
            activeRow = row;
        };


        var possiblyActivate = function (row) {
            var delay = activationDelay();

            if (delay) {
                timeoutId = setTimeout(function () {
                    possiblyActivate(row);
                }, delay);
            } else {
                activate(row);
            }
        };


        var activationDelay = function () {
            if (!activeRow || !$(activeRow).is(options.submenuSelector)) {
                return 0;
            }

            var offset = $menu.offset(),
                upperLeft = {
                    x: offset.left,
                    y: offset.top - options.tolerance
                },
                upperRight = {
                    x: offset.left + $menu.outerWidth(),
                    y: upperLeft.y
                },
                lowerLeft = {
                    x: offset.left,
                    y: offset.top + $menu.outerHeight() + options.tolerance
                },
                lowerRight = {
                    x: offset.left + $menu.outerWidth(),
                    y: lowerLeft.y
                },
                loc = mouseLocs[mouseLocs.length - 1],
                prevLoc = mouseLocs[0];

            if (!loc) {
                return 0;
            }

            if (!prevLoc) {
                prevLoc = loc;
            }

            if (prevLoc.x < offset.left || prevLoc.x > lowerRight.x ||
                prevLoc.y < offset.top || prevLoc.y > lowerRight.y) {
                return 0;
            }

            if (lastDelayLoc &&
                loc.x == lastDelayLoc.x && loc.y == lastDelayLoc.y) {
                return 0;
            }

            function slope(a, b) {
                return (b.y - a.y) / (b.x - a.x);
            };

            var decreasingCorner = upperRight,
                increasingCorner = lowerRight;

            if (options.submenuDirection == "left") {
                decreasingCorner = lowerLeft;
                increasingCorner = upperLeft;
            } else if (options.submenuDirection == "below") {
                decreasingCorner = lowerRight;
                increasingCorner = lowerLeft;
            } else if (options.submenuDirection == "above") {
                decreasingCorner = upperLeft;
                increasingCorner = upperRight;
            }

            var decreasingSlope = slope(loc, decreasingCorner),
                increasingSlope = slope(loc, increasingCorner),
                prevDecreasingSlope = slope(prevLoc, decreasingCorner),
                prevIncreasingSlope = slope(prevLoc, increasingCorner);

            if (decreasingSlope < prevDecreasingSlope &&
                increasingSlope > prevIncreasingSlope) {
                lastDelayLoc = loc;
                return DELAY;
            }

            lastDelayLoc = null;
            return 0;
        };

        $menu
            .mouseleave(mouseleaveMenu)
            .find(options.rowSelector)
            .mouseenter(mouseenterRow)
            .mouseleave(mouseleaveRow)
            .click(clickRow);

        $(document).mousemove(mousemoveDocument);

    };
})(jQuery);


jQuery(document).ready(function ($) {
    //open/close mega-navigation hover	
    $('#menu_shop_all_categories,#category_dropdown').hover(function (event) {
        event.preventDefault();
        toggleNavHoverIn();
    }, function (event) {
        event.preventDefault();
        toggleNavHoverOut();
    });
    //open/close mega-navigation
    $('#menu_shop_all_categories,.modal-open,.back-before').on('click', function (event) {
        event.preventDefault();
        toggleNav();
    });

    // Shop By Brand

    $('#menu_shop_all_brands,#brand_dropdown').hover(function (event) {
        event.preventDefault();
        toggleBrandNavHoverIn();
    }, function (event) {
        event.preventDefault();
        toggleBrandNavHoverOut();
    });
    $('#menu_shop_all_brands,.modal-open,.back-before').on('click', function (event) {
        event.preventDefault();
        toggleBrandNav();
    });

    // Get the App
    $('#menu_get_the_app,#getTheApp_dropdown').hover(function (event) {
      event.preventDefault();
      toggleGetTheAppNavHoverIn();
    }, function (event) {
        event.preventDefault();
        toggleGetTheAppNavHoverOut();
    });
    $('#menu_get_the_app,.modal-open,.back-before').on('click', function (event) {
        event.preventDefault();
        toggleGetTheApp();
    });

    // Guest login dropdown

    $('.mobile-header-bar .login-dropdown-wrapper').on('click', function (event) {
      event.preventDefault();
      toggleGuestLoginMobileClick();
    });


  function toggleGuestLoginMobileClick() {
      if($('.mobile-header-bar .login-dropdown-wrapper').hasClass('login-dropdown-is-active')) {
        $('.mobile-header-bar .login-dropdown-wrapper').removeClass('login-dropdown-is-active');
      } else {
        $('.mobile-header-bar .login-dropdown-wrapper').addClass('login-dropdown-is-active');
      }
      
    }

    $('#close-biiibo-mobile-sidebar').on('click', function (event) {
        event.preventDefault();
        toggleNavMobile();
        // TODO: remove this since we are testing this is working on PROD.
        console.log("Biiibo Bundle TEST");
    });

    $('.cd-dropdown-trigger-mobile').on('click', function (event) {
        event.preventDefault();
        toggleNavMobile();
    });
    //close meganavigation
    $('.cd-dropdown .cd-close').on('click', function (event) {
        event.preventDefault();
        toggleNav();
    });

    //on mobile - open submenu
    $('#mob_menu_wrapper .has-children').children('a').on('click', function (event) {
        //prevent default clicking on direct children of .has-children 
        event.preventDefault();
        var selected = $(this);
        $('#mob_menu_wrapper').scrollTop(0);
        selected.next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('move-out');
    });

    $('#mob-side-menu-shop-department, #mob-side-menu-shop-brands').on('click', function (event) {
      event.preventDefault();
      var selected = $(this);
      $('#mob-side-menu-content').scrollTop(0);
      $('#mob_menu_wrapper').scrollTop(0);
      $('#mob-side-menu-content').addClass('move-out');
      selected.next('ul').removeClass('is-hidden').end().parent('.has-children').parent('ul').addClass('move-out');
    });

    $('#mob_menu_wrapper .go-back-to-main').on('click', function (event) {
      $('#mob-side-menu-content').removeClass('move-out');
      $('#mob_menu_wrapper').addClass('is-hidden');
    });

    $('#mob_brand_menu_wrapper .go-back-to-main').on('click', function (event) {
      $('#mob-side-menu-content').removeClass('move-out');
      $('#mob_brand_menu_wrapper').addClass('is-hidden');
    });
    

    //on desktop - differentiate between a user trying to hover over a dropdown item vs trying to navigate into a submenu's contents
    var submenuDirection = (!$('.cd-dropdown-wrapper category-wrapper').hasClass('open-to-left')) ? 'right' : 'left';
    $('#menu_wrapper').menu({
        activate: function (row) {
            $(row).children().addClass('is-active').removeClass('fade-out');
            if ($('#menu_wrapper .fade-in').length == 0) $(row).children('ul').addClass('fade-in');
        },
        deactivate: function (row) {
            $(row).children().removeClass('is-active');
            if ($('li.has-children:hover').length == 0 || $('li.has-children:hover').is($(row))) {
                $('#menu_wrapper').find('.fade-in').removeClass('fade-in');
                $(row).children('ul').addClass('fade-out')
            }
        },
        exitMenu: function () {
            $('#menu_wrapper').find('.is-active').removeClass('is-active');
            return true;
        },
        submenuDirection: submenuDirection,
    });

    //submenu items - go back link
    $('.go-back').on('click', function () {
        var selected = $(this),
            visibleNav = $(this).parent('ul').parent('.has-children').parent('ul');
        selected.parent('ul').addClass('is-hidden').parent('.has-children').parent('ul').removeClass('move-out');
    });

    function toggleNavHoverIn() {
        $('#category_dropdown').addClass('dropdown-is-active');
        $('#menu_shop_all_categories').toggleClass('dropdown-is-active', true).css({ 'backgroundColor': '' });
    }
    function toggleNavHoverOut() {
        $('#category_dropdown').removeClass('dropdown-is-active');
        $('#menu_shop_all_categories').toggleClass('dropdown-is-active', false).css({ 'backgroundColor': '' });
    }

    function toggleBrandNavHoverIn() {
        $('#brand_dropdown').addClass('dropdown-is-active');
        $('#menu_shop_all_brands').toggleClass('dropdown-is-active', true).css({ 'backgroundColor': '' });

    }
    function toggleBrandNavHoverOut() {
        $('#brand_dropdown').removeClass('dropdown-is-active');
        $('#menu_shop_all_brands').toggleClass('dropdown-is-active', false).css({ 'backgroundColor': '' });

    }

    function toggleGetTheAppNavHoverIn() {
      $('#getTheApp_dropdown').addClass('dropdown-is-active');
      $('#menu_get_the_app').toggleClass('dropdown-is-active', true).css({ 'backgroundColor': '' });
    }
    function toggleGetTheAppNavHoverOut() {
        $('#getTheApp_dropdown').removeClass('dropdown-is-active');
        $('#menu_get_the_app').toggleClass('dropdown-is-active', false).css({ 'backgroundColor': '' });
    }


    function toggleBrandNav() {
        var navIsVisible = (!$('#brand_dropdown').hasClass('dropdown-is-active')) ? true : false;
        $('#brand_dropdown').toggleClass('dropdown-is-active', navIsVisible);
        $('#menu_shop_all_brands').toggleClass('dropdown-is-active', navIsVisible).css({ 'backgroundColor': '' });
        $("body").addClass("modal-open");
        $('.wrap-side-menu').css({ 'display': 'block' });
        // $('.btn-show-menu-mobile').removeClass('is-active')
        if (!navIsVisible) {
            $("body").removeClass("modal-open");
            $('.wrap-side-menu').css({ 'display': 'none' });
            // $('.btn-show-menu-mobile').removeClass('is-active')
            $('#brand_dropdown').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                $('.move-out').removeClass('move-out');
                $('.is-active').removeClass('is-active');
                $('#menu_shop_all_brands').css({ 'backgroundColor': '' });
            });
        }
    }

    function toggleGetTheApp() {
        var navIsVisible = (!$('#getTheApp_dropdown').hasClass('dropdown-is-active')) ? true : false;
        $('#getTheApp_dropdown').toggleClass('dropdown-is-active', navIsVisible);
        $('#menu_get_the_app').toggleClass('dropdown-is-active', navIsVisible).css({ 'backgroundColor': '' });
        $("body").addClass("modal-open");
        $('.wrap-side-menu').css({ 'display': 'block' });
        // $('.btn-show-menu-mobile').removeClass('is-active')
        if (!navIsVisible) {
            $("body").removeClass("modal-open");
            $('.wrap-side-menu').css({ 'display': 'none' });
            // $('.btn-show-menu-mobile').removeClass('is-active')
            $('#getTheApp_dropdown').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                $('.move-out').removeClass('move-out');
                $('.is-active').removeClass('is-active');
                $('#menu_get_the_app').css({ 'backgroundColor': '' });
            });
        }
    }

    function toggleNav() {
        var navIsVisible = (!$('#category_dropdown').hasClass('dropdown-is-active')) ? true : false;
        $('#category_dropdown').toggleClass('dropdown-is-active', navIsVisible);
        $('#menu_shop_all_categories').toggleClass('dropdown-is-active', navIsVisible).css({ 'backgroundColor': '' });
        $("body").addClass("modal-open");
        $('.wrap-side-menu').css({ 'display': 'block' });
        // $('.btn-show-menu-mobile').removeClass('is-active')
        if (!navIsVisible) {
            $("body").removeClass("modal-open");
            $('.wrap-side-menu').css({ 'display': 'none' });
            // $('.btn-show-menu-mobile').removeClass('is-active')
            $('#category_dropdown').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                $('.move-out').removeClass('move-out');
                $('.is-active').removeClass('is-active');
                $('#menu_shop_all_categories').css({ 'backgroundColor': '' });
            });
        }
    }

    // Function to recursively traverse and check children
    function resetOpenedMobileSubElement(element) {
      if ($(element).hasClass('mobile-nested-ul') && !$(element).hasClass('is-hidden')) {
          $(element).addClass('is-hidden');
      }

      $(element).children().each(function() {
        resetOpenedMobileSubElement(this);
      });
    }

    function toggleNavMobile() {
        var navIsVisible = (!$('.cd-dropdown').hasClass('dropdown-is-active')) ? true : false;
        $('.cd-dropdown').not('#guest_login_dropdown').toggleClass('dropdown-is-active', navIsVisible);
        $('.cd-dropdown-trigger').not('#menu_guest_login_dropdown').toggleClass('dropdown-is-active', navIsVisible).css({ 'backgroundColor': '' });
        $("body").addClass("modal-open");
        $('.wrap-side-menu').css({ 'display': 'block' });
        $('.btn-show-menu-mobile').removeClass('is-active');
        // $('.has-children ul').addClass('is-hidden');
        if (!navIsVisible) {
            $("body").removeClass("modal-open");
            $('.wrap-side-menu').css({ 'display': 'none' });
            $('.btn-show-menu-mobile').removeClass('is-active')
            // $('.has-children ul').addClass('is-hidden');
            $('.cd-dropdown').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
                $('.move-out').removeClass('move-out');
                $('.is-active').removeClass('is-active');
                $('.cd-dropdown-trigger').css({ 'backgroundColor': '' });
            });
        }

        // Reset opened submenu
        $('#mob-side-menu-content').removeClass('move-out');
        $('#mob_menu_wrapper').addClass('is-hidden');
        $('#mob_brand_menu_wrapper').addClass('is-hidden');
        resetOpenedMobileSubElement('#mob_menu_wrapper');
        resetOpenedMobileSubElement('#mob_brand_menu_wrappe');
    }

});
